import { Truck, Package, Building2, Car, Archive, Wrench, Utensils, Users as ChefHat, Wine, Leaf, Sparkles, Zap, Wifi, Monitor, CheckCircle, Phone, Boxes } from "lucide-react";
import { Link } from "react-router-dom";

const Services = () => {
  const serviceCategories = [
    {
      id: "moving",
      title: "Moving & Logistics Services",
      icon: <Truck className="w-16 h-16" />,
      color: "from-blue-500 to-blue-600",
      bgColor: "bg-blue-50",
      textColor: "text-blue-600",
      borderColor: "border-blue-200",
      description: "Comprehensive moving and logistics solutions across the UK",
      services: [
        {
          icon: <Truck className="w-10 h-10" />,
          title: "House Moving & Relocation",
          description: "Complete residential moving services for all property sizes",
          price: "From £89",
          features: [
            "Careful packing and handling",
            "Secure loading and transportation",
            "Unpacking and placement",
            "Local and long-distance moves",
            "Furniture protection",
            "Same-day service available"
          ]
        },
        {
          icon: <Building2 className="w-10 h-10" />,
          title: "Office Relocation",
          description: "Professional commercial moving with minimal downtime",
          price: "Custom Quote",
          features: [
            "IT equipment handling",
            "Furniture disassembly/reassembly",
            "After-hours moves",
            "Systematic planning",
            "Secure document handling",
            "Business continuity focus"
          ]
        },
        {
          icon: <Package className="w-10 h-10" />,
          title: "Packing Services",
          description: "Expert packing with professional materials",
          price: "From £49",
          features: [
            "Professional materials",
            "Fragile item protection",
            "Systematic labeling",
            "Unpacking assistance",
            "Custom crating",
            "Eco-friendly options"
          ]
        },
        {
          icon: <Car className="w-10 h-10" />,
          title: "Vehicle Transportation",
          description: "Safe vehicle transport nationwide",
          price: "From £199",
          features: [
            "Enclosed/open transport",
            "Door-to-door delivery",
            "Fully insured",
            "GPS tracking",
            "Classic car specialists",
            "UK-wide coverage"
          ]
        },
        {
          icon: <Archive className="w-10 h-10" />,
          title: "Storage Solutions",
          description: "Secure storage facilities nationwide",
          price: "From £29/week",
          features: [
            "Climate-controlled units",
            "24/7 security & CCTV",
            "Flexible rental periods",
            "Easy access",
            "Various sizes available",
            "Insurance options"
          ]
        },
        {
          icon: <Wrench className="w-10 h-10" />,
          title: "Furniture Assembly",
          description: "Expert furniture handling and assembly",
          price: "From £39",
          features: [
            "Safe disassembly",
            "Proper reassembly",
            "Hardware organization",
            "Flat-pack assembly",
            "No damage guarantee",
            "Professional tools"
          ]
        }
      ]
    },
    {
      id: "catering",
      title: "Food & Catering Logistics",
      icon: <Utensils className="w-16 h-16" />,
      color: "from-orange-500 to-orange-600",
      bgColor: "bg-orange-50",
      textColor: "text-orange-600",
      borderColor: "border-orange-200",
      description: "Specialized logistics and transport for food service industry",
      services: [
        {
          icon: <Utensils className="w-10 h-10" />,
          title: "Catering Equipment Transport",
          description: "Safe transport of catering equipment, supplies, and materials",
          price: "Custom Quote",
          features: [
            "Temperature-controlled vehicles",
            "Catering equipment handling",
            "Event logistics coordination",
            "Time-sensitive delivery",
            "Multiple drop-off points",
            "Professional loading/unloading"
          ]
        },
        {
          icon: <Wine className="w-10 h-10" />,
          title: "Restaurant Relocation",
          description: "Complete logistics for restaurant and kitchen moves",
          price: "From £299",
          features: [
            "Commercial kitchen equipment",
            "Refrigeration unit transport",
            "Furniture and fixtures",
            "Minimal downtime planning",
            "Licensed and insured",
            "Professional installation"
          ]
        },
        {
          icon: <ChefHat className="w-10 h-10" />,
          title: "Food Service Delivery Logistics",
          description: "Regular logistics support for food businesses",
          price: "Custom Quote",
          features: [
            "Scheduled deliveries",
            "Multi-location coordination",
            "Inventory transport",
            "Supplier pickup services",
            "Flexible scheduling",
            "Reliable service"
          ]
        }
      ]
    },
    {
      id: "clearance",
      title: "Light Clearance & Removal Support",
      icon: <Boxes className="w-16 h-16" />,
      color: "from-green-500 to-green-600",
      bgColor: "bg-green-50",
      textColor: "text-green-600",
      borderColor: "border-green-200",
      description: "We assist with general property clearance as part of removals and transport services. For regulated disposal, we work with licensed partners where required.",
      services: [
        {
          icon: <Boxes className="w-10 h-10" />,
          title: "Property Clearance Support",
          description: "Assisting with clearance of unwanted items during removals",
          price: "From £99",
          features: [
            "Pre-move clearance assistance",
            "Furniture removal and transport",
            "General item sorting and loading",
            "Coordination with licensed disposal partners",
            "Same-day clearance available",
            "Residential and commercial properties"
          ]
        },
        {
          icon: <Sparkles className="w-10 h-10" />,
          title: "End-of-Tenancy Clearance",
          description: "Full property clearance for landlords and tenants",
          price: "Custom Quote",
          features: [
            "Complete property clearout",
            "Furniture and appliance removal",
            "Garage and shed clearance",
            "Garden clearance support",
            "Responsible item handling",
            "Licensed partner referrals for disposal"
          ]
        },
        {
          icon: <Leaf className="w-10 h-10" />,
          title: "Light Commercial Clearance",
          description: "Clearance support for offices and business premises",
          price: "From £149",
          features: [
            "Office furniture removal",
            "Equipment clearance",
            "Stock and inventory removal",
            "Post-renovation clearance",
            "Flexible scheduling",
            "Fully insured service"
          ]
        }
      ]
    },
    {
      id: "tech",
      title: "Tech & Equipment Logistics",
      icon: <Zap className="w-16 h-16" />,
      color: "from-red-500 to-red-600",
      bgColor: "bg-red-50",
      textColor: "text-red-600",
      borderColor: "border-red-200",
      description: "Specialized transport for technology and electronic equipment",
      services: [
        {
          icon: <Wifi className="w-10 h-10" />,
          title: "IT Equipment Transport",
          description: "Safe logistics for servers, computers, and IT infrastructure",
          price: "From £149",
          features: [
            "Server room relocation",
            "Computer equipment transport",
            "Anti-static packaging",
            "Secure handling protocols",
            "Insurance coverage",
            "Professional installation"
          ]
        },
        {
          icon: <Monitor className="w-10 h-10" />,
          title: "Office Technology Logistics",
          description: "Complete logistics for office tech equipment",
          price: "Custom Quote",
          features: [
            "Printer and copier moving",
            "Conference room equipment",
            "Networking hardware",
            "Cable management",
            "Setup and testing",
            "Minimal downtime"
          ]
        },
        {
          icon: <Zap className="w-10 h-10" />,
          title: "Electronics & Sensitive Equipment",
          description: "Specialized handling for delicate technology",
          price: "From £129",
          features: [
            "Anti-static protection",
            "Temperature controlled",
            "Shock-resistant packaging",
            "Medical equipment capable",
            "Lab equipment transport",
            "Custom crating available"
          ]
        }
      ]
    }
  ];

  return (
    <div className="w-full" data-testid="services-page">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 via-purple-600 to-orange-500 text-white py-20 md:py-24 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-blue-300 rounded-full mix-blend-multiply filter blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-orange-300 rounded-full mix-blend-multiply filter blur-3xl"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-testid="services-hero-title">
            Specialized Logistics Portfolio
          </h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
            Expert transport and logistics services for residential, commercial, food service, clearance, and technology sectors
          </p>
        </div>
      </section>

      {/* Services by Category */}
      {serviceCategories.map((category, categoryIndex) => (
        <section key={category.id} className={`py-16 md:py-20 ${categoryIndex % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <div className={`inline-flex items-center justify-center bg-gradient-to-br ${category.color} text-white p-4 rounded-2xl mb-6 shadow-lg`}>
                {category.icon}
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">{category.title}</h2>
              <p className="text-xl text-gray-600 max-w-2xl mx-auto">{category.description}</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {category.services.map((service, index) => (
                <div
                  key={index}
                  className={`service-card ${category.bgColor} p-6 rounded-xl shadow-md hover:shadow-xl border-2 ${category.borderColor}`}
                >
                  <div className="flex items-start justify-between mb-4">
                    <div className={`bg-gradient-to-br ${category.color} text-white p-3 rounded-lg`}>
                      {service.icon}
                    </div>
                    <span className={`${category.bgColor} ${category.textColor} px-4 py-2 rounded-full text-sm font-semibold border ${category.borderColor}`}>
                      {service.price}
                    </span>
                  </div>
                  <h3 className={`text-xl font-bold mb-3 ${category.textColor}`}>{service.title}</h3>
                  <p className="text-gray-700 mb-4">{service.description}</p>
                  <div className="border-t pt-4">
                    <h4 className="font-semibold text-gray-900 mb-3 text-sm">What's Included:</h4>
                    <ul className="space-y-2">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="flex items-start space-x-2">
                          <CheckCircle className={`w-4 h-4 ${category.textColor} flex-shrink-0 mt-0.5`} />
                          <span className="text-sm text-gray-700">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}

      {/* CTA Section */}
      <section className="py-16 md:py-20 bg-gradient-to-r from-blue-600 via-purple-600 to-orange-500 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute w-full h-full bg-white rounded-full mix-blend-overlay filter blur-3xl"></div>
        </div>
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Need Specialized Logistics?</h2>
          <p className="text-xl mb-8 text-white/90">
            Contact us for a free consultation and quote tailored to your transport and logistics needs
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="inline-block bg-white text-purple-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gray-100 transition-all shadow-lg"
            >
              Request a Quote
            </Link>
            <a
              href="tel:+447405747177"
              data-testid="services-call-button"
              className="inline-flex items-center justify-center border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-purple-600 transition-all shadow-lg"
            >
              <Phone className="w-5 h-5 mr-2" />
              Call: +44 7405 747177
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
